import { GET, PATCH, POST } from "../../../../helper/xbi4RestFunctions";
export const getPersonalQueriesByFaqId = async (org_id: any, pq_id: any) => {
  const path = `/orgs/${org_id}/personal_queries/${pq_id}
  `;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
